import { Fragment } from "react";

import "./App.css";
import "../../styles/tailwind_tokens.css";
import "../../styles/antd-custom.css";

import { Provider } from "react-redux";
import { store } from "../../redux";
import Router from "../../router";
import { Toaster } from "@/components/ui/sonner";
// import { WelcomeModal } from "../../components/common/WelcomeModal";

function App() {
  return (
    <Provider store={store}>
      <Fragment>
        <Router />
        <Toaster />
        {/* <WelcomeModal /> */}
      </Fragment>
    </Provider>
  );
}

export default App;